module.exports = __webpack_public_path__ + "static/img/150-395.9168720.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loader/150 395/150-395.gif
// module id = ERyW
// module chunks = 0